export default __webpack_public_path__ + "static/extravagant-reno-545473085422466fc507c9a46320dc6f.jpg";